import axios from 'axios';

export const adelectronic = {
  getAdElectronicData(lang = 'th') {
    const selectedLang = lang === 'en' ? 'en' : 'th';

    return axios({
      method: 'GET',
      maxBodyLength: Infinity,
      url: `${process.env.VUE_APP_API}/ad_electronic?lang=${selectedLang}`,
    })
      .then(response => response.data)
      .catch(() => false);
  },
};